// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__M_wj2","row":"Node_row__MR_Y-","label":"Node_label__naQB9","footer":"Node_footer__1PQH3"};